import { render, staticRenderFns } from "./issue_card_weight.vue?vue&type=template&id=4af84077&"
import script from "./issue_card_weight.vue?vue&type=script&lang=js&"
export * from "./issue_card_weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "issue_card_weight.vue"
export default component.exports